import FooterComponent from 'component/layout/footer';
import { Children } from 'react';
import styles from './backLayout.module.scss';

const BackLayout = ({ children, dashboard }) => {
    return (

        <div className={styles.main}>
            <div className={styles.main2}>
                {children}
            </div>
            {!dashboard && <div >
                <div className={styles.shape1} />
                <div className={styles.shape2} />
                <div className={styles.shape3} />
                <div className={styles.shape4} />
                <div className={styles.shape5} />
                <div className={styles.shape6} />
                <div className={styles.shape7} />
            </div>}
            <FooterComponent />
        </div>
    )
}
export default BackLayout

